/**
 * Tax – Sales Tax Returns
 */

export default {
  salesTaxReturns: {
    salesTax: "Sales TAX Returns",
    fillSalesTax: "Here you can fill your Sales TAX Returns",
    fillTaxReturn: "Fill TAX Return",
    stateSearchPlaceholder: "State",
    noStatesFound: "No states found",
    createSalesTaxReturn: "Create Sales Tax return",
    pleaseAddYourTax:
      "Please add your TAX number for state in 'Sales Tax' section",
    clickObSubmit: `By clicking on the 'Submit' button, you agree to the following: When you submit this Sales Tax information you are making a legal declaration that the information is true and complete. A false declaration can result in prosecution`,
    transactionsModal: {
      listTitle: "Gross sales — transactions",
      createTitle: "Add transaction",
      recalculate: "Recalculate",
      submitCreate: "Submit",
      switchCreate: "Add transaction",
      switchList: "Back to list",
      createAmount: "Amount",
      createDate: "Transaction date",
      createReference: "Reference (optional)",
      payloadNote:
        "Field names are aligned with the sales tax transaction API; adjust the submit payload in code if your contract differs from Sales TAX returns.",
      empty: "No transactions for this line.",
    },
  },
};
